import axios from "../utils/axios";

function request(functionId, body) {
  let data = {
    functionId,
    body,
  };
  return axios.request({
    data: data,
    method: "post",
  });
}

// 获取man用户登录信息
export function getContentUserManInfo(body) {
  return request("health_cmp_getContentUserManInfo", body);
}
// 获取man用户权限
export function queryContentUserManInfo(body) {
  return request("health_cmp_biz_queryContentUserManInfo", body);
}
// 标签-新增修改标签租
export function listContentUserManPermissions(body) {
  return request("health_cmp_biz_listUserManPermission", body);
}

// 标签-新增修改标签租
export function saveOrUpdateLabelGroup(body) {
  return request("health_cmp_biz_saveOrUpdateLabelGroup", body);
}

// 标签-删除标签组
export function deleteLabelGroupById(body) {
  return request("health_cmp_biz_deleteContentLabelGroup", body);
}

// 标签-获取标签组分页信息
export function pageContentLabelGroups(body) {
  return request("health_cmp_biz_pageContentLabelGroup", body);
}

// 标签-新增或修改标签
export function saveOrUpdateContentLabel(body) {
  return request("health_cmp_biz_saveOrUpdateContentLabel", body);
}
// 标签-根据父标签id分页查询子标签列表
export function pageContentLabelsByGroupId(body) {
  return request("health_cmp_biz_pageContentLabel", body);
}
// 标签-根据标签id删除标签
export function deleteContentLabelById(body) {
  return request("health_cmp_biz_deleteContentLabel", body);
}
// 标签-查询疾病标签
export function listDiseaseLabels(body) {
  return request("health_cmp_listDiseaseLabels", body);
}

// 标签- 查询用户标签组和标签信息
export function listContentUserLabels(body) {
  return request("health_cmp_biz_pageAuditLabels", body);
}
// // 标签- 查询疾病标签
// export function listDiseaseLabels (body) {
//     return request('health_cmp_listDiseaseLabels', body);
//   }
// 业务配置-分页查询业务信息
export function pageContentBusiness(body) {
  return request("health_cmp_biz_pageContentBusiness", body);
}

// 业务配置-保存或修改业务信息
export function saveOrUpdateContentBusiness(body) {
  return request("health_cmp_biz_saveUpdateBusiness", body);
}

// 业务配置-删除业务信息  health_cmp_deleteContentCategory
export function deleteContentBusiness(body) {
  return request("health_cmp_biz_deleteContentBusiness", body);
}

// 业务配置-获取运营关联的业务信息
export function listContentBusinessForUserMan(body) {
  return request("health_cmp_biz_queryContentUserManInfo", body);
}

// 业务配置-获取运营关联的栏目信息
export function pageCategoriesByBusinessId(body) {
  return request("health_cmp_biz_pageContentCategories", body);
}

//业务配置-保存或修改栏目信息
export function saveOrUpdateContentCategory(body) {
  return request("health_cmp_biz_saveUpdateCategory", body);
}

//业务配置-删除栏目信息
export function deleteContentCategory(body) {
  return request("health_cmp_biz_deleteContentCategory", body);
}

//业务配置-根据栏目id分页查询频道信息
export function pageChannelsByCategoryId(body) {
  return request("health_cmp_biz_pageContentChannels", body);
}

//业务配置-新增或保存频道信息
export function saveOrUpdateContentChannel(body) {
  return request("health_cmp_biz_saveOrUpdateChannel", body);
}

//业务配置-新增或保存频道信息
export function pageContentLabelsByLabelPid(body) {
  return request("health_cmp_biz_pageContentLabel", body);
}

//业务配置-删除频道信息
export function deleteContentChannel(body) {
  return request("health_cmp_biz_deleteContentChannel", body);
}
//业务配置-通过频道id设置排序值
export function setSortContentChannelById(body) {
  return request("health_cmp_biz_setChannelSort", body);
}

// 获取用户开通的业务、栏目、频道信息
export function listContentBizDetailByPin(body) {
  return request("health_cmp_biz_listUserContentBusiness", body);
}

// 业务账号相关接口-根据查询条件分页查询业务账号
// export function pageQueryBusinessAccount(body) {
//   return request("health_cmp_pageQueryBusinessAccount", body);
// }

// 业务账号相关接口-根据查询条件分页查询业务账号  --- 新
export function pageQueryBusinessAccount(body) {
  return request("health_cmp_biz_pageUserManBusiness", body);
}

// 业务账号相关接口-新增业务账号
export function addNewBusinessAccount(body) {
  return request("health_cmp_biz_addContentUserMan", body);
}

// 业务账号相关接口-更改业务账号状态
// export function changheBusinessAccountStatus(body) {
//   return request("health_cmp_changheBusinessAccountStatus", body);
// }

// 业务账号相关接口-更改业务账号状态  --- 新
export function changheBusinessAccountStatus(body) {
  return request("health_cmp_biz_updateBusinessAccountStat", body);
}

// 业务账号相关接口-审核业务账号
export function reviewBusinessAccount(body) {
  return request("health_cmp_biz_auditUserManBusiness", body);
}

// 业务账号相关接口-修改业务账号角色
export function updateBusinessAccountRole(body) {
  return request("health_cmp_biz_updateContentUserManRoles", body);
}
// 查询业务账号各状态的数量
// export function queryBusinessAccountCount(body) {
//   return request("health_cmp_queryBusinessAccountCount", body);
// }

// 查询业务账号各状态的数量  --- 新
export function queryBusinessAccountCount(body) {
  return request("health_cmp_biz_countUserManBusiness", body);
}

// 创作者账号-根据查询条件分页查询创作者账号
// export function pageQueryCreatorAccount(body) {
//   return request("health_cmp_pageQueryCreatorAccount", body);
// }

// 创作者账号-根据查询条件分页查询创作者账号 --- 新
export function pageQueryCreatorAccount(body) {
  return request("health_cmp_biz_pageContentUser", body);
}

// 创作者账号-更改创作者账号状态
export function changheCreatorAccountStatus(body) {
  return request("health_cmp_biz_updateUserAccountStatus", body);
}

// 创作者账号-审核业务账号
export function reviewCreatorAccount(body) {
  return request("health_cmp_biz_auditContentUser", body);
}

// 创作者账号-修改业务账号身份
export function updateCreatorAccountIdentity(body) {
  return request("health_cmp_biz_updateContentUserBusiness", body);
}

// 创作者账号-获取创作者账号全部身份
export function queryAllIdentity(body) {
  return request("health_cmp_biz_listContentUserIdentity", body);
}

// 角色管理-获取角色信息
export function getContentRole(body) {
  return request("health_cmp_biz_queryRole", body);
}

// 角色管理-获取角色列表
export function pageContentRole(body) {
  return request("health_cmp_biz_pageRole", body);
}

// 角色管理-添加或修改角色
export function saveOrUpdateContentRole(body) {
  return request("health_cmp_biz_saveOrUpdateRole", body);
}

// 角色管理-删除角色
export function deleteContentRole(body) {
  return request("health_cmp_biz_deleteRole", body);
}

// // 角色管理-获取用户端菜单权限
// export function listContentUserManPermissions (body) {
//     return request(' health_cmp_listContentUserManPermissions', body);
// }

// 保存用户配置
export function manSaveUserConfig(body) {
  return request("health_cmp_biz_manSaveUserConfig", body);
}
// 查询用户配置
export function manListUserConfig(body) {
  return request("health_cmp_biz_manListUserConfig", body);
}

//内容审核与上下线-查询文章列表
export function queryArticleList(body) {
  return request("health_cmp_queryArticleList", body);
}

//内容审核与上下线-获取各个审核状态文章数量
export function getAllArticleCounts(body) {
  // return request("health_cmp_getAllArticleCounts", body);
  return request("health_cmp_biz_getAllArticleCounts", body);
}

//内容审核与上下线-根据id文章详情
export function getArticleByPid(body) {
  return request("health_cmp_biz_manQueryArticleById", body);
}

//内容审核与上下线-根据id更新文章
export function updateArticleByPid(body) {
  return request("health_cmp_biz_manUpdateArticle", body);
  // return request("health_cmp_updateArticleByArticleId", body);
}
//2.13 设置精选、取消精选文章
export function setArticleBadgeStatus(body) {
  // return request("health_cmp_setArticleBadgeStatus", body);
  return request("health_cmp_biz_manBadgeArticle", body);
}

//内容审核与上下线-审核通过文章
export function manPassArticle(body) {
  return request("health_cmp_biz_manPassArticle", body);
  // return request("health_cmp_manPassArticle", body);
}

//内容审核与上下线-驳回文章
export function manRejectArticle(body) {
  return request("health_cmp_biz_manRejectArticle", body);
  // return request("health_cmp_manRejectArticle", body);
}

//内容审核与上下线-审核通过下线文章
export function passOfflineArticle(body) {
  // return request("health_cmp_passOfflineArticle", body);
  return request("health_cmp_biz_manPassOfflineArticle", body);
}

//内容审核与上下线-审核驳回下线文章
export function rejectOfflineArticle(body) {
  // return request("health_cmp_rejectOfflineArticle", body);
  return request("health_cmp_biz_manRejectOfflineArticle", body);
}

//内容审核与上下线-运营下线文章
export function manOfflineArticle(body) {
  // return request("health_cmp_manOfflineArticle", body);
  return request("health_cmp_biz_manOfflineArticle", body);
}

//内容审核与上下线-查看线上
export function onlineViewArticle(body) {
  return request("health_cmp_biz_generateContentOnlineLink", body);
}
//内容审核与上下线-预览文章
export function manGetPreviewInfoByIdForPin(body) {
  return request("health_cmp_manGetPreviewInfoByIdForPin", body);
}
// 内容审核与上下线-根据名称查询原始作者信息
export function getOriginalAuthorsByName(body) {
  return request("health_cmp_listByDoctorName", body);
}
// 标签属性
export function getTagAttributes(body) {
  return request("health_cmp_biz_updateLabelGroupInvisible", body);
}
/**
 置顶、取消置顶文章
 tenantId  租户id  Long  是
  id
  文章id  Integer  是
  isTop  置顶状态，1置顶，0取消置顶  Integer  是
*/
export function setArticleTopStatus(body) {
  // return request('health_cmp_setArticleTopStatus', body);
  return request("health_cmp_biz_manTopArticle", body);
}

//------------------------------------权限申请-----------------------------------------------------------
//分页查询运营人员业务权限列表
export function pageBusinessPermissionsApply(body) {
  return request("health_cmp_biz_pageManBusinessApplies", body);
}
//申请业务权限
export function applyBusinessPermission(body) {
  return request("health_cmp_biz_applyBusiness", body);
}
// 查询创作者账号各状态数量
// export function queryCreatorAccountCount(body) {
//   return request("health_cmp_queryCreatorAccountCount", body);
// }

// 查询创作者账号各状态数量 --- 新
export function queryCreatorAccountCount(body) {
  return request("health_cmp_biz_countContentUser", body);
}

//运营端文章审核与上下线-----------------疾病检索
export function listDiseaseInfoByName(body) {
  return request("health_cmp_pageDiseaseInfoByParam", body);
}

// 运营端---获取审核文章时的标签组和标签信息
export function listContentLabelsForAudit(body) {
  return request("health_cmp_biz_pageAuditLabels", body);
}

// 运营端 -------- 查询文章审核时展示的业务信息
export function listContentBizDetailForAudit(body) {
  return request("health_cmp_listContentBizDetailForAudit", body);
}

// 导入类目
export function importInArticleCategory(body) {
  return request("health_cmp_biz_importExcel", body);
}
// 导出类目
export function importExArticleCategory(body) {
  return request("health_cmp_biz_exportExcel", body);
}
// 导出导出轮询
export function importExportLog(body) {
  return request("health_cmp_biz_queryExcelResult", body);
}
// ------------------------疾病百科-------------------------
//疾病百科-获取各个审核状态疾病百科数量
export function getDiseaseDraftCountList(body) {
  return request("health_cmp_getDiseaseDraftCountList", body);
}
//疾病百科-获取疾病百科列表
export function pageDiseaseInfoDraftList(body) {
  return request("health_cmp_pageDiseaseInfoDraftList", body);
}
//疾病百科-获取驳回理由
export function getAuditReason(body) {
  return request("health_cmp_getAuditReason", body);
}
//疾病百科-更改疾病百科上下线状态
export function updateDiseaseStatus(body) {
  return request("health_cmp_updateDiseaseStatus", body);
}
//疾病百科-通过文章id查看线上疾病信息
export function onlineViewContent(body) {
  return request("health_cmp_onlineViewContent", body);
}
//疾病百科-查询科室信息
export function queryDepartments(body) {
  return request("health_cmp_queryDepartmentsWithDisease", body);
}
// 疾病百科-- 根据关键词模糊查询疾病名称
export function searchDiseaseInfoByParam(body) {
  return request("health_cmp_manSearchDiseaseInfoByParam", body);
}
export function listTenantContentLabels(body) {
  return request("health_cmp_biz_pageAuditLabels", body);
}
// 对接查重功能
export function queryContentRiskControl(body) {
  body.appid = "health-bianque-man";
  return request("health_cmp_queryContentRiskControl", body);
}
export function querySnippetRiskControl(body) {
  body.appid = "health-bianque-man";
  return request("health_cmp_biz_querySnippetRiskControl", body);
}
export function executeContentRiskControl(body) {
  body.appid = "health-bianque-man";
  return request("health_cmp_executeContentRiskControl", body);
}

// 评论管理-审核通过
export function passCommentInfo(body) {
  return request("health_cmp_business_passCommentInfo", body);
}

// 评论管理-置顶
export function addCommentInfoTopStatus(body) {
  return request("health_cmp_business_addCommentTopStatus", body);
}
// 评论管理-取消置顶
export function cancelCommentInfoTopStatus(body) {
  return request("health_cmp_business_cancelTopStatus", body);
}

// 部位标签新增
export function newPartLabel(body) {
  return request("health_cmp_saveBodyPart", body);
}
// 修改部位标签
export function modifyPartLabel(body) {
  return request("health_cmp_updateBodyPartById", body);
}
// 删除部位标签
export function deletePartLabel(body) {
  return request("health_cmp_deleteBodyPartById", body);
}
// 查询部位标签
export function queryPartLabel(body) {
  return request("health_cmp_queryBodyParts", body);
}

// 评论管理-分页查询
export function pageManCommentInfos(body) {
  return request("health_cmp_business_pageManCommentInfos", body);
}

// 评论管理-审核驳回
export function rejectCommentInfo(body) {
  return request("health_cmp_business_rejectCommentInfo", body);
}
// 评论管理-删除评论
export function deleteManCommentInfo(body) {
  return request("health_cmp_business_deleteManCommentInfo", body);
}

export function health_cmp_biz_setCommentLevel(body) {
  return request("health_cmp_biz_setCommentLevel", body);
}

// 获取医生信息列表
export function getDoctorInformation(body) {
  return request("health_cmp_listByDoctorName", body);
}
// 获取症状部位
export function healthCmpQueryBodyParts(body) {
  return request("health_cmp_queryBodyParts", body);
}

export function healthCmpBizPageDuplicateRecord(body) {
  return request("health_cmp_biz_pageDuplicateRecord", body);
}

export function healthCmpBizRiskControlFileParse(body) {
  return request("health_cmp_biz_riskControlFileParse", body);
}

export function healthCmpBizSaveContentSnippet(body) {
  return request("health_cmp_biz_saveContentSnippet", body);
}

export function healthCmpBizExecuteSnippetRiskControl(body) {
  return request("health_cmp_biz_executeSnippetRiskControl", body);
}
export function healthCmpBizPageContentSnippet(body) {
  return request("health_cmp_biz_pageContentSnippet", body);
}
export function healthCmpBizDeleteContentSnippet(body) {
  return request("health_cmp_biz_deleteContentSnippet", body);
}
export function healthCmpBizQueryByContentSnippetId(body) {
  return request("health_cmp_biz_queryByContentSnippetId", body);
}

export function healthCmpBizQueryVaccineCategories(body) {
  return request("health_cmp_biz_queryVaccineCategories", body);
}

// 内容搬运 - 分页查询自媒体认证信息
export function manPageMediaCertification(body) {
  return request("health_cmp_biz_manPageMediaCertification", body);
}

// 内容搬运 - 查询自媒体认证列表数量
export function manCountMediaCertificatio(body) {
  return request("health_cmp_biz_manCountMediaCertificatio", body);
}

// 内容搬运 - 创作者认证审核
export function manAuditMediaCertificatio(body) {
  return request("health_cmp_biz_manAuditMediaCertificatio", body);
}
// 百科管理 - 检查指标百科 下载导入数据模板
export function getImportTemplate(body) {
  return request("health_cmp_biz_getImportTemplate", body);
}

// 专业问答 - 药品列表
export function pgcSelectList(body) {
  return request("health_pgc_selectList", body);
}

// 专业问答 - 查看回答（回答列表）
export function pgcSelectDrugQuestionAndAnswers(body) {
  return request("health_pgc_selectDrugQuestionAndAnswers", body);
}

// 专业问答 - 批量删除（删回答）
export function pgcBatchdelQuestion(body) {
  return request("health_pgc_batchdelQuestion", body);
}

// 专业问答 - 批量删除问题和sku绑定关系
export function pgcBatchdel(body) {
  return request("health_pgc_batchdel", body);
}

// 专业问答 - 编辑问答
export function pgcUpdateQuestionAndAnswer(body) {
  return request("health_pgc_updateQuestionAndAnswer", body);
}

// 专业问答 - 回答关联药品
export function pgcSelectQuestionSkuList(body) {
  return request("health_pgc_selectQuestionSkuList", body);
}

// 专业问答 - 导入
export function pgcImportQuestionAndAnswer(body) {
  return request("health_pgc_importQuestionAndAnswer", body);
}

// 专业问答 - 批量导出问答
export function pgcExportQuestionAndAnswer(body) {
  return request("health_pgc_exportQuestionAndAnswer", body);
}

// 患者病例 - 查询导入地址
export function pcdDrugQueryImport(body) {
  return request("health_pcs_drug_excelTemplateUrl", body);
}

// 患者病例 - 查询导入地址
export function pcdSkuQueryImport(body) {
  return request("health_pcs_sku_excelTemplateUrl", body);
}

// 患者病例 - 导入
export function pcdDrugImportQuestionAndAnswer(body) {
  return request("health_pcs_drug_importExcel", body);
}

// 患者病例 - 导入
export function pcdSkuImportQuestionAndAnswer(body) {
  return request("health_pcs_sku_importExcel", body);
}

// 患者病例 - 婴幼儿导入
export function pcdChildImportQuestionAndAnswer(body) {
  return request("health_pcs_sku_child_importExcel", body);
}

// 患者病例 - 宠物导入
export function pcdPetImportQuestionAndAnswer(body) {
  return request("health_pcs_sku_pet_importExcel", body);
}
// 患者病例 - 批量导出问答
export function pcdDrugExportQuestionAndAnswer(body) {
  return request("health_pcs_drug_exportExcel", body);
}

// 患者病例 - 批量导出问答
export function pcdSkuExportQuestionAndAnswer(body) {
  return request("health_pcs_sku_exportExcel", body);
}

// 患者病例 - 批量导出婴幼儿
export function pcdChildExportQuestionAndAnswer(body) {
  return request("health_pcs_sku_child_exportExcel", body);
}

// 患者病例 - 批量导出问答
export function pcdPetExportQuestionAndAnswer(body) {
  return request("health_pcs_sku_pet_exportExcel", body);
}

// 专业问答 - 操作记录查询
export function pgcQueryRecordsByParam(body) {
  return request("health_pgc_queryRecordsByParam", body);
}

// 谣言管理 - 列表
export function rumorPageRumor(body) {
  return request("health_cmp_biz_pageRumor", body);
}

// 谣言管理 - 详情
export function rumorQueryRumor(body) {
  return request("health_cmp_biz_man_queryRumor", body);
}

// 谣言管理 - 修改
export function rumorUpdateRumor(body) {
  return request("health_cmp_biz_updateRumor", body);
}

// 谣言管理 - 新增
export function rumorSaveRumor(body) {
  return request("health_cmp_biz_saveRumor", body);
}

// 分页查询导入导出信息
export function pageImportExportResult(body) {
  return request("health_cmp_biz_pageImportExportResult", body);
}

// 反馈 - 分页查询交互记录
export function pageOperations(body) {
  return request("health_cmp_biz_pageOperations", body);
}

// 反馈 - 反馈处理
export function processOperation(body) {
  return request("health_cmp_biz_processOperation", body);
}

// 反馈 - 处理状态数量查询
export function countProcessStatus(body) {
  return request("health_cmp_biz_countProcessStatus", body);
}

// 反馈 - 分页查询反馈处理数据
export function pageOperationProcess(body) {
  return request("health_cmp_biz_pageOperationProcess", body);
}

// 查询内容大模型推荐的标签
export function queryLargeModelLabel(body) {
  return request("health_cmp_business_queryLargeModelLabel", body);
}

// 刷新内容大模型推荐的标签（异步）
export function queryRefreshLMLabel(body) {
  return request("health_cmp_business_refreshLMLabel", body);
}

// 置顶问答
export function healthPgcTopPgcQuestionId(body) {
  return request("health_pgc_topPgcQuestionId", body);
}

// 批量提交审核通过
export function health_cmp_biz_batchPassComments(body) {
  return request("health_cmp_biz_batchPassComments", body);
}
// 批量提交驳回评论
export function health_cmp_biz_batchRejectComments(body) {
  return request("health_cmp_biz_batchRejectComments", body);
}
// 批量提交删除评论
export function health_cmp_biz_deleteRejectComments(body) {
  return request("health_cmp_biz_deleteRejectComments", body);
}

// 批量恢复评论
export function health_cmp_biz_batchRecoveryComments(body) {
  return request("health_cmp_biz_batchRecoveryComments", body);
}

// 帖子运营
// 标签管理
// 新增标签
export function jdh_qz_man_post_label_add(body) {
  return request("jdh_qz_man_post_label_add", body);
}
// 更新标签
export function jdh_qz_man_post_label_update(body) {
  return request("jdh_qz_man_post_label_update", body);
}
// 逻辑删除
export function jdh_qz_man_post_label_remove(body) {
  return request("jdh_qz_man_post_label_remove", body);
}
// 物理删除
export function jdh_qz_man_post_label_delete(body) {
  return request("jdh_qz_man_post_label_delete", body);
}
// 分页查询
export function jdh_qz_man_post_label_page(body) {
  return request("jdh_qz_man_post_label_page", body);
}

export function jdh_qz_man_activity_add_category(body) {
  return request("jdh_qz_man_activity_add_category", body);
}

export function jdh_qz_man_activity_update_category(body) {
  return request("jdh_qz_man_activity_update_category", body);
}

export function jdh_qz_man_activity_page_categories(body) {
  return request("jdh_qz_man_activity_page_categories", body);
}

export function jdh_qz_man_activity_add(body) {
  return request("jdh_qz_man_activity_add", body);
}

export function jdh_qz_man_activity_update(body) {
  return request("jdh_qz_man_activity_update", body);
}

export function jdh_qz_man_activity_page(body) {
  return request("jdh_qz_man_activity_page", body);
}

export function jdh_qz_man_activity_add_post_relation(body) {
  return request("jdh_qz_man_activity_add_post_relation", body);
}

export function jdh_qz_man_activity_update_post_relation(body) {
  return request("jdh_qz_man_activity_update_post_relation", body);
}

export function jdh_qz_man_activity_bu_post_relation(body) {
  return request("jdh_qz_man_activity_bu_post_relation", body);
}

export function jdh_qz_man_activity_page_posts(body) {
  return request("jdh_qz_man_activity_page_posts", body);
}

export function jdh_qz_man_activity_post_import(body) {
  return request("jdh_qz_man_activity_post_import", body);
}

export function jdh_qz_man_widget_post_import(body) {
  return request("jdh_qz_man_widget_post_import", body);
}

export function jdh_qz_man_activity_post_export(body) {
  return request("jdh_qz_man_activity_post_export", body);
}

export function health_cmp_queryCommentSourceFilter(body) {
  return request("health_cmp_queryCommentSourceFilter", body);
}

export function health_cmp_pageCommentAutoReplyConfig(body) {
  return request("health_cmp_pageCommentAutoReplyConfig", body);
}

export function health_cmp_deleteCommentAutoReplyConfig(body) {
  return request("health_cmp_deleteCommentAutoReplyConfig", body);
}

export function health_cmp_upsertCommentAutoReplyConfig(body) {
  return request("health_cmp_upsertCommentAutoReplyConfig", body);
}
export function health_cmp_queryAllCommentCounts(body) {
  return request("health_cmp_queryAllCommentCounts", body);
}
export function jdh_qz_man_query_post_type_enum(body) {
  return request("jdh_qz_man_query_post_type_enum", body);
}
export function jdh_qz_man_page(body) {
  return request("jdh_qz_man_page", body);
}
export function jdh_qz_man_query_post_level_enum(body) {
  return request("jdh_qz_man_query_post_level_enum", body);
}

export function jdh_man_privateLetterSession_page(body) {
  return request("jdh_man_privateLetterSession_page", body);
}
export function jdh_man_dongDongMsg_page(body) {
  return request("jdh_man_dongDongMsg_page", body);
}
export function health_pgc_queryExportTemplate(body) {
  return request("health_pgc_queryExportTemplate", body);
}

export function health_pgc_importDeleteByType(body) {
  return request("health_pgc_importDeleteByType", body);
}

export function jdh_qz_man_post_types(body) {
  return request("jdh_qz_man_post_types", body);
}
